import { Injectable } from '@angular/core';
import { NavigationCancel, NavigationEnd, NavigationExtras, NavigationStart, Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class RoutingService {
    private backupPreviousUrl: string | undefined;
    private previousUrl: string;
    private currentUrl: string;

    constructor(private readonly router: Router) {
        this.initialize();
    }

    private initialize(): void {
        this.currentUrl = this.router.url;
        this.router.events.subscribe(event => {
            if (event instanceof NavigationStart) {
                this.backupPreviousUrl = this.previousUrl;
                this.previousUrl = this.currentUrl;
                this.currentUrl = event.url;
            }
            if (event instanceof NavigationCancel) {
                if (this.backupPreviousUrl) {
                    this.previousUrl = this.backupPreviousUrl;
                }
            }
            if (event instanceof NavigationEnd) {
                this.backupPreviousUrl = undefined;
            }
        });
    }

    getPreviousContext(): string | undefined {
        return this.previousUrl;
    }

    navigateToPreviousContext(fallbackRoute: any[], fallbackRouteArgs?: NavigationExtras): void {
        if (typeof this.previousUrl === 'undefined') {
            this.router.navigate(fallbackRoute, fallbackRouteArgs);
        } else {
            this.router.navigateByUrl(this.previousUrl);
        }
    }
}
